"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PRODUCT_TYPES_NAME = exports.PRODUCT_TYPES = exports.PRODUCT_CATEGORIES = void 0;
var PRODUCT_CATEGORIES;
(function (PRODUCT_CATEGORIES) {
    PRODUCT_CATEGORIES[PRODUCT_CATEGORIES["STANDALONE"] = 1] = "STANDALONE";
    PRODUCT_CATEGORIES[PRODUCT_CATEGORIES["BUNDLE"] = 2] = "BUNDLE";
    PRODUCT_CATEGORIES[PRODUCT_CATEGORIES["ADDON"] = 3] = "ADDON";
})(PRODUCT_CATEGORIES = exports.PRODUCT_CATEGORIES || (exports.PRODUCT_CATEGORIES = {}));
;
var PRODUCT_TYPES;
(function (PRODUCT_TYPES) {
    PRODUCT_TYPES[PRODUCT_TYPES["CURSO"] = 1] = "CURSO";
    PRODUCT_TYPES[PRODUCT_TYPES["PROGRAMA"] = 2] = "PROGRAMA";
    PRODUCT_TYPES[PRODUCT_TYPES["MEMBRESIA"] = 3] = "MEMBRESIA";
    PRODUCT_TYPES[PRODUCT_TYPES["LICENCIA"] = 4] = "LICENCIA";
    PRODUCT_TYPES[PRODUCT_TYPES["CREDITO_ASESORIA"] = 5] = "CREDITO_ASESORIA";
    PRODUCT_TYPES[PRODUCT_TYPES["FUNCIONALIDAD"] = 6] = "FUNCIONALIDAD";
    PRODUCT_TYPES[PRODUCT_TYPES["SERVICIO"] = 7] = "SERVICIO";
    PRODUCT_TYPES[PRODUCT_TYPES["NIVEL_SOPORTE"] = 8] = "NIVEL_SOPORTE";
    PRODUCT_TYPES[PRODUCT_TYPES["PRODUCTO_FISICO"] = 9] = "PRODUCTO_FISICO";
    PRODUCT_TYPES[PRODUCT_TYPES["TRAMITE"] = 10] = "TRAMITE";
})(PRODUCT_TYPES = exports.PRODUCT_TYPES || (exports.PRODUCT_TYPES = {}));
;
exports.PRODUCT_TYPES_NAME = {
    [PRODUCT_TYPES.CURSO]: 'Curso',
    [PRODUCT_TYPES.PROGRAMA]: 'Programa',
    [PRODUCT_TYPES.MEMBRESIA]: 'Membresía',
    [PRODUCT_TYPES.LICENCIA]: 'Licencia',
    [PRODUCT_TYPES.CREDITO_ASESORIA]: 'Crédito Asesoría',
    [PRODUCT_TYPES.FUNCIONALIDAD]: 'Funcionalidad',
    [PRODUCT_TYPES.SERVICIO]: 'Servicio',
    [PRODUCT_TYPES.NIVEL_SOPORTE]: 'Nivel de Soporte',
    [PRODUCT_TYPES.PRODUCTO_FISICO]: 'Producto Físico',
    [PRODUCT_TYPES.TRAMITE]: 'Trámite',
};
